module.exports = __webpack_public_path__ + "static/header-background-pattern-a3fd2b474876b7e323975303f7a6669a.png";